<template>
  <div class="station-file-tree">
    <a-tree
      showLine
      showIcon
      :defaultExpandAll="false"
      :treeData="treeData"
      :selectedKeys="selectedKeys"
      :expandedKeys="expandedKeys"
      :loadedKeys="loadedKeys"
      :loadData="loadData"
      @select="(keys, info) => onSelectTree(keys, info.node.dataRef)"
      @expand="expandKey"
    >
      <template slot="customTitle" slot-scope="item">
        <div class="custom-tree-item">
          <span>{{ item.title }}</span>

          <template v-if="item.expanded">
            <a-icon
              slot="switcherIcon"
              type="folder-open"
              theme="filled"
              style="color: #4a90e2; font-size: 16px; position: absolute; left: -25px; top: 4px; z-index: 10;"
            />
          </template>

          <template v-else>
            <a-icon
              slot="switcherIcon"
              type="folder"
              theme="filled"
              style="color: #4a90e2; font-size: 16px; position: absolute; left: -25px; top: 4px; z-index: 10;"
            />
          </template>
        </div>
      </template>
      <template slot="neibuTitle" slot-scope="item">
        <div class="custom-tree-item">
          <a-tag color="blue" v-if="item.internalStorage">
            {{ $t('page_dnc_station_file_internal_storage') }}
          </a-tag>
          <span>{{ item.title }}</span>
        </div>
      </template>
    </a-tree>
  </div>
</template>

<script>
import {
  TransferDirectoryGroupServiceProxy,
  TransferDirectoryQueryServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'
import { WorkStationSettingServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
const tdgsp = new TransferDirectoryGroupServiceProxy()
const tdqsp = new TransferDirectoryQueryServiceProxy()
const wsssp = new WorkStationSettingServiceProxy()
export default {
  data() {
    return {
      treeData: [],
      selectedInfo: {},
      pInfo: {},
      loadedKeys: [], // 懒加载树节点
      expandedKeys: [] // 展开树节点
    }
  },
  props: {
    selectedKeys: {
      // 选择树节点
      type: Array,
      default: () => []
    },
    tabValue: {
      type: String,
      default: '1'
    }
  },
  watch: {
    tabValue: {
      handler() {
        this.treeData = []
        this.getTree()
      },
      immediate: true,
      deep: true
    },
    selectedKeys: {
      handler() {
        if (this.selectedKeys && this.selectedKeys.length) {
          this.findInfo(this.treeData, this.selectedKeys[0])
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getTree()
  },
  methods: {
    findInfo(treeData, id) {
      treeData.forEach((value) => {
        if (value.key === id) {
          this.selectedInfo = value
          this.$emit('selectedInfo', value)
        } else {
          if (value.children && value.children.length) {
            this.findInfo(value.children, id)
          }
        }
      })
    },
    onSelectTree(selectedKeys) {
      if (!selectedKeys.length) {
        return
      }
      this.$emit('selectTree', selectedKeys)
    },
    expandKey(value) {
      this.expandedKeys = value
    },
    async getTree() {
      // 我的文档树目录
      this.expandedKeys = []
      this.$emit('selectTree', [])
      this.$emit('selectedInfo', {})
      this.loadedKeys = []
      const res = await tdgsp.treeList()
      this.treeData = [
        {
          title: this.$t('page_docdirectory_manage_menu'),
          key: '0',
          id: '0',
          scopedSlots: { title: 'customTitle' },
          children: []
        }
      ]
      if (res) {
        const childrens = this.nodeTree(res, '0')
        this.treeData[0].children = childrens
      }
    },
    loadData(treeNode) {
      return new Promise((resolve) => {
        const data = treeNode.dataRef ? treeNode.dataRef : treeNode
        this.pushKey(this.treeData, data.key)
        if (data.key.indexOf('-') === -1) {
          tdqsp
            .findTransferDirectoryList(data.key)
            .then((res) => {
              if (res && res.length > 0) {
                data.children = [...this.loadTree(res, data.key), ...data.children]
                data.isLeaf = false
                this.treeData = [...this.treeData]
                resolve()
              } else {
                data.children = [...data.children]
                data.isLeaf = false
                this.treeData = [...this.treeData]
                resolve()
              }
            })
            .catch(() => {
              data.children = [...data.children]
              data.isLeaf = false
              this.treeData = [...this.treeData]
              resolve()
            })
        } else {
          if (this.tabValue === '1') {
            wsssp
              .getWorkStationById(data.id)
              .then((res) => {
                if (res && res.length > 0) {
                  data.children = this.loadWorkStataion(res, data.key)
                  data.isLeaf = false
                  this.treeData = [...this.treeData]
                  resolve()
                } else {
                  data.children = [...data.children]
                  data.isLeaf = false
                  this.treeData = [...this.treeData]
                  resolve()
                }
              })
              .catch(() => {
                data.children = [...data.children]
                data.isLeaf = false
                this.treeData = [...this.treeData]
                resolve()
              })
          } else {
            data.children = [...data.children]
            data.isLeaf = false
            this.treeData = [...this.treeData]
            resolve()
          }
        }
      })
    },
    loadWorkStataion(value, pid) {
      const node = []
      value.forEach((element) => {
        const item = {
          title: element.name || element.code,
          key: element.id,
          id: element.id,
          scopedSlots: { title: 'neibuTitle' },
          isLeaf: false,
          parentId: pid,
          appCode: element.iotAppCode,
          gateWayCode: element.iotCode,
          internalStorage: element.internalStorage,
          children: []
        }
        if (element.children && element.children.length) {
          item.children = this.loadWorkStataion(element.children, element.id)
        }
        node.push(item)
      })
      return node
    },
    loadTree(value, pid) {
      const node = []
      value.forEach((element) => {
        const item = {
          title: element.name,
          key: pid + '-' + element.id,
          id: element.id,
          scopedSlots: { title: this.tabValue === '1' ? 'customTitle' : 'fileTitle' },
          selectable: this.tabValue === '1' ? false : true,
          isLeaf: false,
          parentId: pid,
          children: []
        }
        if (element.children && element.children.length) {
          item.children = this.loadTree(element.children, element.id)
        }
        node.push(item)
      })
      return node
    },
    pushKey(data, key) {
      if (data && data.length > 0) {
        data.forEach((item) => {
          if (item.key === key) {
            if (this.expandedKeys.indexOf(item.key) === -1) {
              this.loadedKeys.push(item.key)
            }
            if (this.loadedKeys.indexOf(item.key) === -1) {
              this.loadedKeys.push(item.key)
            }
            if (item.parentId) {
              this.pushKey(this.treeData, item.parentId)
            }
          } else {
            if (item.children && item.children.length > 0) {
              this.pushKey(item.children, key)
            }
          }
        })
      }
    },
    nodeTree(value, pid) {
      const node = []
      value.forEach((element) => {
        const item = {
          title: element.data ? element.data.name : element.title,
          key: element.id,
          scopedSlots: { title: 'customTitle' },
          selectable: false,
          isLeaf: false,
          parentId: pid,
          children: []
        }
        if (element.children && element.children.length) {
          item.children = this.nodeTree(element.children, element.id)
        }
        node.push(item)
      })
      return node
    }
  }
}
</script>

<style lang="less" scoped>
.station-file-tree {
  width: 313px;
  height: 100%;
  background-color: #ffffff;
  border-radius: 2px;
  border: solid 1px #d8d8d8;
  overflow-y: auto;
  overflow-x: hidden;

  /deep/ .ant-tabs {
    overflow: inherit;
  }

  /deep/ .ant-tabs-bar {
    bottom: -1px;
    border-bottom: 1px solid #d9d9d9;
    margin: 0;
  }

  /deep/ .ant-tabs .ant-tabs-small-bar .ant-tabs-tab {
    padding: 9px 16px;
    margin: 0;
    width: 50%;
    text-align: center;
  }

  /deep/ .ant-tabs-nav {
    width: 100%;
  }

  /deep/ .ant-tabs-nav .ant-tabs-tab:first-child {
    border-right: 1px solid #d9d9d9;
  }

  /deep/ .ant-tabs-nav .ant-tabs-tab-active {
    background-color: #fff;
  }

  /deep/ .ant-tabs-ink-bar {
    top: -1px !important;
    z-index: 99;
    background-color: #4b91e2;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    bottom: auto;
    height: 4px;
  }
  /deep/ .ant-radio-group {
    width: 100%;
  }
  /deep/.ant-radio-button-wrapper {
    width: 50%;
    text-align: center;
  }
  /deep/ .ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {
    visibility: hidden;
  }

  /deep/ .ant-tree-treenode-selected > span .right-drop-down {
    display: block !important;
  }

  /deep/ .ant-tree.ant-tree-show-line li span.ant-tree-switcher {
    background-color: transparent;
  }

  /deep/ .ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {
    opacity: 0 !important;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper {
    width: calc(100% - 24px);
    /*background-color: #d0edff;*/
  }

  /deep/ .ant-tree-title {
    position: relative;
  }

  /deep/ .ant-tree-switcher {
    color: rgba(0, 0, 0, 0) !important;
    position: relative;
    z-index: 99;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: rgb(255, 241, 184);
  }
}
</style>
